import { RoleService } from '../../services/role.service';
import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Role } from '../../models/role.model';
import { PagedInput } from '../../models/page-input.model';
import { PagedResult } from '../../models/paged-result.model';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserRoleAddDialogComponent } from '../user-role-add-dialog/user-role-add-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Status } from '../../models/status.model';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss'],
})
export class RoleListComponent implements OnInit {
  dataSource!: MatTableDataSource<Role>;
  rolesData!: PagedResult<Role>;
  displayedColumns: string[] = [
    'name',
    'createdBy',
    'dateCreated',
    'statusType',
    'actions'
  ];
  searchForm!: FormGroup;
  searchData!: Role;
  statusList!: Status[];
  selectedRole!: Role;

  @Output() selectedRoleToEmit = new EventEmitter<Role>();
  @ViewChild(MatSort) sort!: MatSort;

  constructor(public dialog: MatDialog,
    private roleService: RoleService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder) { }

  ngOnInit(): void {

    this.statusList = [{ id: true, name: 'Active' }, { id: false, name: 'Inactive' }];

    this.searchForm = this.fb.group({
      name: [null],
      active: [null]
    });

    this.rolesData = this.activatedRoute.snapshot.data['roles'];
    this.dataSource = new MatTableDataSource(this.rolesData.results);

    this.searchData = this.searchForm.value;

    if (this.rolesData.results?.length > 0) {
      this.selectedRole = this.rolesData.results[0];
      this.selectedRoleToEmit.emit(this.selectedRole);
    }
  }

  onSearch() {
    this.searchData = this.searchForm.value;
    this.getRoles();
  }


  reset() {
    this.searchForm.reset();
    this.searchData = this.searchForm.value;
    this.getRoles();
  }

  onRoleEdit(row: Role) {
    this.onRowClick(row);
    this.openUserRoleAddDialog(row);
  }

  onRowClick(role: Role) {
    this.selectedRole = role;

    this.selectedRoleToEmit.emit(role);
    //this.getRoles(role.id);
  }

  getRoles(pagination?: { pageSize: number; currentPage: number }) {
    const payload: PagedInput = {
      pageSize: pagination?.pageSize ?? this.pageSize,
      currentPage: pagination?.currentPage ?? this.pageIndex + 1,
    };

    this.roleService.getRoles(this.searchData, payload).subscribe({
      next: (response) => {
        this.rolesData = response;
        this.dataSource = new MatTableDataSource(response.results);

        if (response.results?.length > 0) {
          this.selectedRole = response.results[0];
          this.selectedRoleToEmit.emit(this.selectedRole);
        } else {
        }
      },
      error: (err) => {
        console.error('Error fetching roles:', err);
      }
    });

  }

  sortData(sort: Sort) {
    console.log('Sort triggered:', sort);

    const sortColumnMap: Record<string, string> = {
      name: 'name',
      createdBy: 'createdBy',
      dateCreated: 'dateCreated',  
      statusType: 'statusType'
    };

    const mappedColumn = sortColumnMap[sort.active] || sort.active;

    const payload = {
      ...this.searchForm.value,
      sortColumn: mappedColumn,
      sortDirection: sort.direction,
      pageSize: this.pageSize,
      currentPage: 1
    };

    console.log('Final sort payload to API:', payload);

    this.roleService.getRoles(payload, payload).subscribe({
      next: (response) => {
        this.rolesData = response;
        this.dataSource = new MatTableDataSource(response.results);
      },
      error: (err) => console.error('Error sorting roles:', err)
    });
  }

  get totalLength() {
    return this.rolesData.rowCount;
  }
  get pageSize() {
    return this.rolesData.pageSize;
  }
  get pageIndex() {
    return this.rolesData.currentPage - 1;
  }
  get hasRows() {
    return this.rolesData.rowCount !== 0;
  }

  page(event: PageEvent) {
    this.getRoles({
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize
    } as PagedInput);
  }

  openUserRoleAddDialog(role?: Role): void {
    const dialogRef = this.dialog.open(UserRoleAddDialogComponent, {
      width: '450px',
      data: role
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getRoles();
    });
  }
}
